import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  RATESDETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';


const fetchRatesDetails = async gid => axiosAuthInstance.get(`/internal${API_END_POINTS.RATES}/${gid}`);

const DeleteRate = async gid => axiosAuthInstance.delete(`/internal${API_END_POINTS.RATES}/${gid}`);

export function* getRatesDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchRatesDetails, action.payload);
    yield put({ type: RATESDETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: RATESDETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* deleteRate(action) {
  try {
    yield put({ type: LOADING.VALIDATING });
    yield put({ type: LOADING.SUBMITTING });
    yield call(DeleteRate, action.payload);
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.RATES.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
